import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Контакты - Проминнова</title>
        <meta
          name="description"
          content="Свяжитесь с компанией Проминнова для заказа трансформаторов ТСЛ и ТСЗ, КТПН, КСО. Бесплатная консультация, индивидуальный подход, доставка по РФ и СНГ."
        />
      </Helmet>

      <div className="bg-primary-50 py-12">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Свяжитесь с Проминнова для заказа оборудования
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Оставьте заявку или свяжитесь с нами любым удобным способом. Мы на связи в рабочее время
            с 9:00 до 18:00 по московскому времени
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 mb-8">
              <h2 className="text-2xl font-bold mb-6">Наши контакты</h2>

              <div className="space-y-6">
                <div className="flex items-start">
                  <Phone className="w-5 h-5 text-primary-600 mt-1 mr-4" />
                  <div>
                    <div className="font-medium mb-1">Телефон</div>
                    <a
                      href="tel:+79137701139"
                      className="text-lg hover:text-primary-600 transition-colors"
                    >
                      +7 (913) 770-11-39
                    </a>
                    <div className="text-sm text-gray-500">Бесплатно по России</div>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail className="w-5 h-5 text-primary-600 mt-1 mr-4" />
                  <div>
                    <div className="font-medium mb-1">Email</div>
                    <a
                      href="mailto:prominnova@mail.ru"
                      className="text-lg hover:text-primary-600 transition-colors"
                    >
                      prominnova@mail.ru
                    </a>
                    <div className="text-sm text-gray-500">Для заявок и вопросов</div>
                  </div>
                </div>

                <div className="flex items-start">
                  <MapPin className="w-5 h-5 text-primary-600 mt-1 mr-4 flex-shrink-0" />
                  <div className="flex-1">
                    <div className="font-medium mb-1">Адрес</div>
                    <div className="text-lg">
                      Основное производство и склад продукции в г.Новосибирск. Для наших клиентов
                      действуют центры присутсвия в г Пермь, Хабаровск, Владивосток, Сахалин,
                      Москва, н. Новгород
                    </div>
                    <div className="text-sm text-gray-500">Офис и склад</div>
                  </div>
                </div>

                <div className="flex items-start">
                  <Clock className="w-5 h-5 text-primary-600 mt-1 mr-4" />
                  <div>
                    <div className="font-medium mb-1">Режим работы</div>
                    <div className="text-lg">Пн-Пт: с 10:00 до 22:00</div>
                    <div className="text-sm text-gray-500">По московскому времени</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8">
              <h2 className="text-2xl font-bold mb-6">Реквизиты компании</h2>

              <div className="space-y-4">
                <div>
                  <div className="text-sm text-gray-500">Полное наименование</div>
                  <div>Общество с ограниченной ответственностью ПО «Промышленные Инновации»</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8">
              <h2 className="text-2xl font-bold mb-6">Оставить заявку</h2>
              <ContactForm />
            </div>
          </div>
        </div>

        <div className="mt-12">
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8">
            <h2 className="text-2xl font-bold mb-6">Как добраться</h2>
            <div className="h-96 rounded-lg overflow-hidden">
              {/* Replace with actual map iframe */}
              <div style={{ position: 'relative', overflow: 'hidden' }}>
                <a
                  href="https://yandex.ru/maps/org/promyshlennyye_innovatsii/165102861472/?utm_medium=mapframe&utm_source=maps"
                  style={{ color: '#eee', fontSize: '12px', position: 'absolute', top: '0px' }}
                >
                  Промышленные Инновации
                </a>
                <a
                  href="https://yandex.ru/maps/65/novosibirsk/category/energy_equipment/184107082/?utm_medium=mapframe&utm_source=maps"
                  style={{ color: '#eee', fontSize: '12px', position: 'absolute', top: '14px' }}
                >
                  Энергетическое оборудование в Новосибирске
                </a>
                <a
                  href="https://yandex.ru/maps/65/novosibirsk/category/electrical_products/184107066/?utm_medium=mapframe&utm_source=maps"
                  style={{ color: '#eee', fontSize: '12px', position: 'absolute', top: '28px' }}
                >
                  Электротехническая продукция в Новосибирске
                </a>
                <iframe
                  src="https://yandex.ru/map-widget/v1/?ll=82.915700%2C54.961062&mode=search&oid=165102861472&ol=biz&sctx=ZAAAAAgBEAAaKAoSCa7UsyCUulRAEZs3TgrzektAEhIJiIIZU7DGeT8RMgQAx549Zz8iBgABAgMEBSgKOABArp0GSAFqAnJ1nQHNzMw9oAEAqAEAvQHsGq3jwgEGoPmWh%2BcEggIr0J%2FRgNC%2B0LzRi9GI0LvQtdC90L3Ri9C1INCY0L3QvdC%2B0LLQsNGG0LjQuIoCAJICAJoCDGRlc2tvcC1tYXBz%3D%3D&sll=82.915700%2C54.961062&source=serp_navig&sspn=0.010880%2C0.004906&text=%D0%9F%D1%80%D0%BE%D0%BC%D1%8B%D1%88%D0%BB%D0%B5%D0%BD%D0%BD%D1%8B%D0%B5%20%D0%98%D0%BD%D0%BD%D0%BE%D0%B2%D0%B0%D1%86%D0%B8%D0%B8&z=17.25"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  allowFullScreen={true}
                  style={{ position: 'relative', height: '600px' }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
